import { render, staticRenderFns } from "./table-wait-approval.vue?vue&type=template&id=2ac65c4c"
import script from "./table-wait-approval.vue?vue&type=script&lang=js"
export * from "./table-wait-approval.vue?vue&type=script&lang=js"
import style0 from "./table-wait-approval.vue?vue&type=style&index=0&id=2ac65c4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports